import { Modal } from '@smartgift/frontend-toolkit';
import React, { useEffect, useState } from 'react';

import { STEP } from './constant';
import { NewContactForm } from './NewContactForm';
import { SelectAddingType } from './SelectAddingType';
import { SpreadSheet } from './SpreadSheet';

const steps = {
  [STEP.select]: SelectAddingType,
  [STEP.form]: NewContactForm,
  [STEP.spreadSheet]: SpreadSheet
};

function NewContactModal({ openModal, onRequestClose, onUpdatingDone, selectedTag }) {
  const [modalHeader, setModalHeader] = useState({});
  const [footerProps, setFooterProps] = useState({});

  const [activeScene, setActiveScene] = useState(STEP.select);

  useEffect(() => {
    return () => {
      setActiveScene(STEP.select);
    };
  }, [openModal]);

  const ActiveComponent = steps[activeScene];

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onRequestClose}
      {...modalHeader}
      primaryButtonProps={{
        children: footerProps.rightButtonText,
        onClick: footerProps.rightButtonOnClick,
        disabled: !footerProps.isRightButtonActive,
        endIcon: footerProps.rightButtonEndIcon
      }}
      secondaryButtonProps={{
        onClick: footerProps.leftButtonOnClick,
        children: footerProps.leftButtonText,
        disabled: !footerProps.isLeftButtonActive
      }}
    >
      <ActiveComponent
        setActiveScene={setActiveScene}
        setFooterProps={setFooterProps}
        setModalHeader={setModalHeader}
        onRequestClose={onRequestClose}
        onUpdatingDone={onUpdatingDone}
        selectedTag={selectedTag}
      />
    </Modal>
  );
}

export { NewContactModal };
